export const WINDOW_TMS_PROPERTY = 'tms';
export const WINDOW_DATALAYER_PROPERTY = 'tc_vars';
export const TmsEvent = {
  EVENT: 'TMSEvent',
  DATA_LAYER_READY: 'TMSDataLayerReady',
  DATA_LAYER_CHANGE: 'TMSDataLayerChange',
  VIRTUAL_PAGE_READY: 'TMSVirtualPageReady'
};

const dispatchTmsEvent = (target, eventType, value) => {
  const tmsEvent = new CustomEvent(TmsEvent.EVENT, {
    detail: {
      eventType,
      value
    }
  });
  target.dispatchEvent(tmsEvent);
};

export const hitEventTms = (target, eventType, data = {}) => {
  if (typeof data === 'string') {
    data = JSON.parse(data);
  }
  if (
    window[WINDOW_DATALAYER_PROPERTY] &&
    window[WINDOW_DATALAYER_PROPERTY].cdl_datalayer_ready === true
  ) {
    dispatchTmsEvent(target, eventType, data);
  } else {
    window.addEventListener(
      TmsEvent.DATA_LAYER_READY,
      () => {
        // Timeout at 0 to delay this listener after others that uses TMS "ready" signal
        setTimeout(() => {
          dispatchTmsEvent(target, eventType, data);
        }, 0);
      },
      { once: true }
    );
  }
};

export const appendToTcVarsGlobal = component => {
  if (component.target.dataset.tcvars) {
    component.componentTcVarsReady({
      tcvars: JSON.parse(component.target.dataset.tcvars.replace(/'/g, '"'))
    });
  }
};

export const appendToTcVarsComponent = function(objectToAppend) {
  if (typeof objectToAppend !== 'object') {
    return;
  }

  let updatedTcVars = [];
  if (this.target.dataset.tcvars) {
    const fixedTcVars = this.target.dataset.tcvars.replace(/'/g, '"');
    updatedTcVars = JSON.parse(`[${fixedTcVars}]`);
  }
  updatedTcVars.push(objectToAppend);
  this.target.dataset.tcvars = JSON.stringify(updatedTcVars);
};

export const getTmsInstance = () => {
  return (
    window[WINDOW_TMS_PROPERTY] ??
    new Proxy(
      {},
      {
        get() {
          return () => () => undefined;
        }
      }
    )
  ); // Placeholder if TMS is missing;
};
